module.exports = __webpack_public_path__ + "static/media/39-6.877a0085.mp3";